import { ChangeEvent, useEffect, useState } from 'react';

import { TextField } from '@mui/material';

import { IQuestion } from 'pages/task/types';

interface FreeTextProps {
  value: string | string[] | null;
  question: IQuestion;
  setAnswer: (key: string) => void;
}

const FreeText = ({ value, question, setAnswer }: FreeTextProps) => {
  const inputValue = Array.isArray(value) ? value.join(', ') : value || '';
  const [tempAnswer, setTempAnswer] = useState<string>('');
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setTempAnswer(event.target.value);
  };

  const handleBlur = () => {
    setAnswer(tempAnswer);
  };

  useEffect(() => {
    setTempAnswer(inputValue);
  }, [inputValue]);

  return (
    <TextField
      data-testid="textfield-option-component"
      label={question.label}
      placeholder={question.placeholder || ''}
      value={tempAnswer}
      onChange={handleChange}
      onBlur={handleBlur}
      type="text"
      fullWidth
      sx={{ mb: 3 }}
    />
  );
};

export default FreeText;
